import RmDriverModal from './rm-driver-modal.vue'
export default RmDriverModal
